export default __webpack_public_path__ + "static/media/excel_icon.a5478581.svg";